<template>
  <div class="purchase-success-view">
    <FloatingHeader
      title="Compra Realizada"
      sbtitle=""
      :showHeader="true"
      :hideSearch="true"
      :routeToBack="'/'"
      :hide-arrow-back="!isFullApp"
    />

    <div class="view-content-ps">
      <div class="view-content-icon">
        <img src="@/assets/img/success.svg" alt="Success" class="success-icon" />
      </div>

      <div class="view-content-message">
        <h2>Compra Realizada!</h2>
        <p v-if="isFullApp">
          Agradecemos pela sua compra. Você poderá evitar filas no estádio e resgatar seus produtos com mais facilidade.
        </p>
        <p v-else>
          Agradecemos pela sua compra! O link para acessar seu pedido foi enviado por e-mail.
        </p>
        <p>O cupom fiscal será enviado para o seu e-mail.</p>
      </div>

      <div class="bottom-content">
        <div class="view-content-button">
          <DefaultButton
            :text="isFullApp ? 'Finalizar' : 'Ver meu pedido'"
            @defaultBtnClick="handlePrimaryAction"
          />
        </div>
        <!-- v-if isFullApp:  solucao paliativa para a demanda Sodexo, para que alunos nao tenham acesso ao cardapio dos funcionarios -->
        <div class="ticket" @click="handleSecondaryAction" v-if="isFullApp">
          <span>{{ isFullApp ? 'Ir para o ticket' : 'Voltar ao Cardápio' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'PurchaseSuccessView',
  components: {
    FloatingHeader,
    DefaultButton
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['isFullApp'])
  },
  methods: {
    handlePrimaryAction () {
      if (this.isFullApp) {
        this.$router.push('/')
      } else {
        this.$router.push({ path: '/orders', query: { newOrder: 'true' } })
      }
    },
    handleSecondaryAction () {
      if (this.isFullApp) {
        this.$router.push({ path: '/orders', query: { newOrder: 'true' } })
      } else {
        this.$router.push('/event')
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
.purchase-success-view {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: env(safe-area-inset-top) 20px 0;

  .view-content-ps {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .view-content-icon {
      margin-bottom: 20px;

      .success-icon {
        width: 150px;
        height: 150px;
        animation: fadeInScale 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
      }
    }

    .view-content-message {
      margin-bottom: 20px;
      max-width: 320px;
      animation: fadeIn 0.5s ease-out 0.4s both;
      opacity: 0;

      h2 {
        font-size: 24px;
        margin-bottom: 10px;
      }

      p {
        font-size: 16px;
        color: #666;
        line-height: 1.5;
      }
    }

    .bottom-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px 20px env(safe-area-inset-bottom);
      animation: fadeIn 0.5s ease-out 0.8s both;
      opacity: 0;

      .ticket {
        margin-top: 20px;
        cursor: pointer;

        span {
          font-size: 16px;
          font-weight: 600;
          color: var(--primaryColor);
        }
      }

      .view-content-button button {
        min-width: 300px !important;
        height: 55px !important;
        margin: 5px !important;
        border: none;
        background: var(--primaryColor);
        color: white;
      }
    }
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
